import toast from 'react-hot-toast';

/**
 * Affiche un message quand l'API refuse une action faute de permission.
 *
 * Le garde API (php/App/Permission/PermissionGuard.php) répond 403 avec
 * `error.code = 'PERMISSION_DENIED'`. Beaucoup d'écrans n'examinent pas le code
 * de retour de leurs appels : sans ce relais, une action refusée échouerait en
 * silence. On observe donc toutes les réponses, une seule fois, à l'installation.
 */
let installed = false;

const installPermissionDeniedNotifier = () => {
  if (installed || typeof window === 'undefined' || !window.fetch) return;
  installed = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (response.status === 403) {
      response.clone().json()
        .then((body) => {
          if (body?.error?.code === 'PERMISSION_DENIED') {
            toast.error(body.message || "Vous n'avez pas la permission d'effectuer cette action.", { id: 'permission-denied' });
          }
        })
        .catch(() => null); // corps non JSON : pas un refus de permission
    }
    return response;
  };
};

export default installPermissionDeniedNotifier;
